<template>
  <div>
    <a-tabs v-model="activeTab">
      <a-tab-pane key="subtitle" tab="副标题展示合计">
        <div ref="chartSubtitle" style="width: 800px; height: 400px" />
      </a-tab-pane>
      <a-tab-pane key="group" tab="图表中增加“合计”一组">
        <div ref="chartGroup" style="width: 800px; height: 400px" />
      </a-tab-pane>
      <a-tab-pane key="table" tab="图表+表格展示合计">
        <div ref="chartTable" style="width: 800px; height: 400px" />
        <table border="1" style="margin-top: 16px; min-width: 400px">
          <tr>
            <th>合计任务数</th>
            <th>合计任务Point数</th>
            <th>合计缺陷数</th>
            <th>合计百Point缺陷数</th>
          </tr>
          <tr>
            <td>3496</td>
            <td>7432</td>
            <td>922</td>
            <td>12.41</td>
          </tr>
        </table>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { Tabs } from 'ant-design-vue';
export default {
  components: { 'a-tabs': Tabs, 'a-tab-pane': Tabs.TabPane },
  data() {
    return {
      activeTab: 'subtitle'
    };
  },
  watch: {
    activeTab() {
      this.$nextTick(() => {
        this.renderAllCharts();
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.renderAllCharts();
    });
  },
  methods: {
    renderAllCharts() {
      this.renderSubtitleChart();
      this.renderGroupChart();
      this.renderTableChart();
    },
    renderSubtitleChart() {
      const 团队 = ['启元', '极光', '航海时代', '架构组', '香港项目'];
      const 任务数 = [1206, 837, 863, 206, 384];
      const 任务Point数 = [2476, 1796, 1847, 434, 879];
      const 缺陷数 = [326, 177, 244, 112, 63];
      const 百Point缺陷数 = [13.17, 9.86, 13.21, 25.81, 7.17];
      const option = {
        title: {
          text: '1月20日 ~ 6月30日 团队任务与缺陷数据',
          subtext: '合计：任务数 3496，任务Point数 7432，缺陷数 922，百Point缺陷数 12.41',
          left: 'center'
        },
        tooltip: { trigger: 'axis' },
        legend: { data: ['任务数', '任务Point数', '缺陷数', '百Point缺陷数'], top: 30 },
        xAxis: { type: 'category', data: 团队 },
        yAxis: [
          { type: 'value', name: '数量' },
          { type: 'value', name: '百Point缺陷数', position: 'right' }
        ],
        series: [
          { name: '任务数', type: 'bar', data: 任务数 },
          { name: '任务Point数', type: 'bar', data: 任务Point数 },
          { name: '缺陷数', type: 'bar', data: 缺陷数 },
          { name: '百Point缺陷数', type: 'line', yAxisIndex: 1, data: 百Point缺陷数 }
        ]
      };
      const chart = echarts.init(this.$refs.chartSubtitle);
      chart.setOption(option);
    },
    renderGroupChart() {
      const 团队 = ['启元', '极光', '航海时代', '架构组', '香港项目', '合计'];
      const 任务数 = [1206, 837, 863, 206, 384, 3496];
      const 任务Point数 = [2476, 1796, 1847, 434, 879, 7432];
      const 缺陷数 = [326, 177, 244, 112, 63, 922];
      const 百Point缺陷数 = [13.17, 9.86, 13.21, 25.81, 7.17, 12.41];
      const option = {
        title: {
          text: '1月20日 ~ 6月30日 团队任务与缺陷数据（含合计）',
          left: 'center'
        },
        tooltip: { trigger: 'axis' },
        legend: { data: ['任务数', '任务Point数', '缺陷数', '百Point缺陷数'], top: 30 },
        xAxis: { type: 'category', data: 团队 },
        yAxis: [
          { type: 'value', name: '数量' },
          { type: 'value', name: '百Point缺陷数', position: 'right' }
        ],
        series: [
          { name: '任务数', type: 'bar', data: 任务数 },
          { name: '任务Point数', type: 'bar', data: 任务Point数 },
          { name: '缺陷数', type: 'bar', data: 缺陷数 },
          { name: '百Point缺陷数', type: 'line', yAxisIndex: 1, data: 百Point缺陷数 }
        ]
      };
      const chart = echarts.init(this.$refs.chartGroup);
      chart.setOption(option);
    },
    renderTableChart() {
      const 团队 = ['启元', '极光', '航海时代', '架构组', '香港项目'];
      const 任务数 = [1206, 837, 863, 206, 384];
      const 任务Point数 = [2476, 1796, 1847, 434, 879];
      const 缺陷数 = [326, 177, 244, 112, 63];
      const 百Point缺陷数 = [13.17, 9.86, 13.21, 25.81, 7.17];
      const option = {
        title: {
          text: '1月20日 ~ 6月30日 团队任务与缺陷数据',
          left: 'center'
        },
        tooltip: { trigger: 'axis' },
        legend: { data: ['任务数', '任务Point数', '缺陷数', '百Point缺陷数'], top: 30 },
        xAxis: { type: 'category', data: 团队 },
        yAxis: [
          { type: 'value', name: '数量' },
          { type: 'value', name: '百Point缺陷数', position: 'right' }
        ],
        series: [
          { name: '任务数', type: 'bar', data: 任务数 },
          { name: '任务Point数', type: 'bar', data: 任务Point数 },
          { name: '缺陷数', type: 'bar', data: 缺陷数 },
          { name: '百Point缺陷数', type: 'line', yAxisIndex: 1, data: 百Point缺陷数 }
        ]
      };
      const chart = echarts.init(this.$refs.chartTable);
      chart.setOption(option);
    }
  }
};
</script>

<style scoped>
.ant-tabs {
  margin-bottom: 16px;
}
</style>
